import type { ReactNode } from 'react';
import { DashboardFooter } from './DashboardFooter';
import { NavigationBar } from './NavigationBar';

interface AppLayoutProps {
  sidebar?: ReactNode;
  children: ReactNode;
  detailPanel?: ReactNode;
}

export function AppLayout({ sidebar, children, detailPanel }: AppLayoutProps) {
  return (
    <div className="flex h-screen bg-background">
      <div className="flex flex-col flex-1">
        {/* Global Navigation Bar */}
        <NavigationBar />

        <div className="flex flex-1 overflow-hidden">
          {/* Contextual Sidebar */}
          {sidebar && <aside className="w-64 border-r bg-card overflow-y-auto">{sidebar}</aside>}

          {/* Main Content Area with Footer */}
          <main className="flex-1 flex flex-col overflow-hidden">
            <div className="flex-1 overflow-auto">{children}</div>
            <DashboardFooter />
          </main>

          {/* Optional Detail Panel */}
          {detailPanel && (
            <aside className="w-80 border-l bg-card overflow-y-auto">{detailPanel}</aside>
          )}
        </div>
      </div>
    </div>
  );
}
